import { ReactElement } from "react";
import { ContentCard, Row } from "@narmi/design_system";
import { DrawerRow } from ".";

const DrawerCard = ({
  title,
  rows,
}: {
  title: string;
  rows: Array<[string, string | undefined | ReactElement<any>]>;
}) => {
  if (rows.length) {
    return (
      <div className="margin--top--xl">
        <Row>
          <Row.Item>
            <h5 className="margin--bottom--xs fontColor--secondary fontWeight--bold">
              {title.toUpperCase()}
            </h5>
          </Row.Item>
        </Row>
        <ContentCard kind="bordered">
          {rows.map((row, index) => (
            <DrawerRow
              key={index}
              row={row}
              index={index}
              totalRows={rows.length}
            />
          ))}
        </ContentCard>
      </div>
    );
  }

  return null;
};

export default DrawerCard;
